import { z } from 'zod';
/**
 * Contratto dell'import brand dal pannello di amministrazione.
 *
 * Unità di import = un singolo oggetto brand. A ogni caricamento
 * il brand esistente viene sostituito integralmente: cancella-e-reimporta.
 */
export const importBrandRequestSchema = z.object({
    /** L'oggetto brand grezzo, validato lato server contro lo schema v2.4. */
    brand: z.unknown(),
    /** Company a cui associare il brand. Se omessa resta non assegnato. */
    companyId: z.uuid().optional(),
    /**
     * Conferma esplicita richiesta quando la validazione produce avvisi non
     * bloccanti: il primo invio li restituisce, il secondo procede.
     */
    acknowledgeWarnings: z.boolean().optional(),
});
/**
 * Caricamento in blocco di tutti i brand di un file `{ brands: [...] }`.
 *
 * L'unità di import resta il brand: il server valida e scrive ogni oggetto con
 * le stesse regole del caricamento singolo, ma in **una sola transazione** —
 * o passano tutti o non si scrive nulla. Nessuna company: il JSON non la
 * contiene e un'associazione unica per tutto il file non avrebbe senso, quindi
 * i brand nuovi restano non assegnati e quelli già presenti conservano la loro.
 */
export const importBrandsBulkRequestSchema = z.object({
    brands: z.array(z.unknown()).min(1),
    acknowledgeWarnings: z.boolean().optional(),
});
export const IMPORT_WARNING_CODES = [
    /**
     * Unico controllo sullo storico: avviso NON bloccante se il nuovo oggetto
     * porta meno snapshot di quello già presente. Accodare la storia è
     * responsabilità di chi produce l'analisi (spec §8.2).
     */
    'history_shorter_than_stored',
    /** Campi rimossi dalla specifica ancora presenti: conversione con template vecchio. */
    'removed_fields_present',
    /**
     * Chiavi che lo schema non dichiara e che quindi non finiscono a database.
     * `z.object` le scarta in silenzio: senza questo avviso un campo introdotto da
     * una revisione futura della specifica verrebbe accettato e perso, con 201 e
     * nessun segnale.
     */
    'unknown_fields_dropped',
    /** Il brand cambia settore rispetto alla versione già a database. */
    'sector_changed',
    /** Il brand non è associato ad alcuna company: non sarà visibile a nessun cliente. */
    'brand_unassigned',
    /**
     * Solo nel caricamento in blocco, sempre presente: avvisa che non è possibile
     * associare i brand a una company, e conta quelli che resteranno non assegnati.
     * Sostituisce `brand_unassigned`, che ripetuto per ogni brand sarebbe rumore.
     */
    'bulk_company_not_assignable',
];
//# sourceMappingURL=import.js.map